import { useMemo } from "react";

import type { DaySchedule } from "@/domain/prayer/types";
import { applyJummahForFriday } from "@/lib/applyJummahForFriday";

import { usePrayerSchedule } from "./usePrayerSchedule";
import { useJummahSettings, usePrayerSettings } from "./useSettings";

/**
 * Bundles the today + tomorrow schedules with Friday's Dhuhr slot substituted
 * for the masjid's Jummah times. All UI surfaces that display the timetable
 * should use this hook so the Jummah substitution stays consistent.
 */
export function useDisplaySchedule(now: Date): {
  today: DaySchedule;
  tomorrow: DaySchedule;
} {
  const prayer = usePrayerSettings();
  const jummah = useJummahSettings();
  const { today, tomorrow } = usePrayerSchedule(prayer, now);

  return useMemo(
    () => ({
      today: applyJummahForFriday(today, jummah.azaanTime, jummah.jamaahTime),
      tomorrow: applyJummahForFriday(tomorrow, jummah.azaanTime, jummah.jamaahTime),
    }),
    [today, tomorrow, jummah.azaanTime, jummah.jamaahTime],
  );
}
